import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { StudioDetailsInterface } from '../interfaces/studio-details';

const getStudioDetails = async (
  id: string = ''
): Promise<StudioDetailsInterface | null> => {
  if (id === '') return null;
  try {
    const {
      data: { data },
    } = await axios.get(`/api/Studio/Details/${id}?dc=${Date.now()}`);

    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const useStudioDetails = (id: string = '', key: string = '') => {
  return useQuery({
    queryFn: async () => getStudioDetails(id),
    queryKey: ['details', 'studio', id, key],
    retry: 2,
    retryDelay: 180000,
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
